import { Injectable, inject } from '@angular/core';
import { IdentityServerDataService } from '@shared/services/identityserver-data.service';

@Injectable({
  providedIn: 'root',
})
export class MarketingPreferencesService {
  private readonly identityServerDataService = inject(IdentityServerDataService);

  public setMarketingPreferencesAsRead() {
    return this.identityServerDataService.post('marketingpreferences/setMarketingPreferencesAsRead', {});
  }
}
